import { ExpenseReportAnalyticGroup } from "@common/utils/graphql";
import { Body } from "@hypercard/web-components";

const RENDER_AMOUNT: Record<
  ExpenseReportAnalyticGroup,
  (data: any) => React.ReactNode
> = {
  [ExpenseReportAnalyticGroup.Category]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.Department]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.Employee]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.ExpenseStatus]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.Merchant]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.PaymentMethod]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.PolicyStatus]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.ReportStatus]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.Reviewer]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.CustomField]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
  [ExpenseReportAnalyticGroup.Manager]: (data) => {
    return (
      <Body size="sm" weight="regular">
        {data}
      </Body>
    );
  },
};

export const renderAmount = (groupBy: ExpenseReportAnalyticGroup, data: any) =>
  RENDER_AMOUNT[groupBy](data);
